<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 7px">
          Müşteri Gsm Onay (Yeni Üyeler)
        </h3>
        <button
          class="btn btn-outline-primary btn-sm float-right"
          @click="addManuel()"
          style="margin-left: 5px"
          v-if="game == null && auth.CustomerGsmNew != null && auth.CustomerGsmNew.isWrite"
        >
          <i class="fas fa-plus"></i> Manuel Hak Ekle
        </button>
      </div>
      <div class="card-body">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="process">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <div class="callout callout-danger" v-if="message != null">
            <p class="text-center">
              <span v-html="message"></span>
            </p>
          </div>
          <div class="callout callout-success" v-if="game != null">
            <p class="text-center">
              <span v-html="game"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 7px">
          Müşteri Gsm Onay (Yeni Üyeler) Logları
        </h3>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive p-0" style="height: 400px">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="overlay">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <table
            class="table table-head-fixed text-nowrap table-striped projects"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Tarih</th>
                <th>Gsm Numarası</th>
                <th>Onay Kodu</th>
                <th>Deneme Sayısı</th>
                <th>Talep</th>
                <th>Durum</th>
                <th>Mesaj</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in datas" :key="index">
                <td>{{ ++index }}</td>
                <td>{{ data.date | DateFormat }}</td>
                <td>{{ data.phone }}</td>
                <td>{{ data.code }}</td>
                <td>{{ data.deneme }}</td>
                <td>{{ data.isType ? "Casino Bonus" : "Spor Bonus" }}</td>
                <td>{{ getStatus(data) }}</td>
                <td>{{ data.message }}</td>
              </tr>
              <tr>
                <td v-if="datas.length == 0" colspan="8" class="text-center">
                  Kayıt Bulunamadı
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["customer"],
  data() {
    return {
      datas: [],
      game: null,
      message: null,
      search: "",
      overlay: false,
      process: false,
      auth: this.$store.getters.getModules,
    };
  },

  methods: {
    getDatas() {
      this.overlay = true;
      this.$http
        .get("GsmNewCustomer/ListRequest/" + this.customer.code)
        .then((response) => {
          this.datas = response.data;
          this.overlay = false;
        });
    },
    getControl() {
      this.process = true;
      this.$http.get("GsmNewCustomer/GsmControl/" + this.customer.code).then(
        (response) => {
          this.game = response.data;
          this.message = null;
          this.process = false;
        },
        (error) => {
          this.message = error.data.Message;
          this.game = null;
          this.process = false;
        }
      );
    },
    getStatus(item) {
      let status = "";
      if (item.isRed) status = "Üye Reddetti";
      else if (!item.isSuccess) status = "Gsm Doğrulanmadı";
      else if (!item.isValid || item.isRecord)
        status = "Bonus Ataması Bekliyor";
      else if (item.isError && !item.isRecord) status = "Bonus Verilmedi";
      else status = "Bonus Verildi";

      return status;
    },

    addManuel() {
      this.process = true;
      this.$http.get("GsmNewCustomer/GsmManuelAdd/" + this.customer.code).then(
        (response) => {
          toastr.success("Kayıt Başarlı");
          this.getControl();
          this.process = false;
        },
        (error) => {
          toastr.error(
            "İşlem yapılırken hata oluştu! Lütfen tekrar deneyiniz."
          );
          this.process = false;
        }
      );
    },

    deleteManuel(code, type) {
      Swal.fire({
        title: "Müşterinin manuel hakkı silinecek! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Sil",
        cancelButtonText: "İptal",
        icon: "question",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.process = true;
          this.$http
            .get("Scratch/GamesManuelDelete/" + this.customer.code)
            .then((response) => {
              toastr.success("Kayıt başarıyla silindi.");
              this.process = false;
              this.getControl();
            });
        }
      });
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },

  created() {
    this.getDatas();
    this.getControl();
  },
   watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerGsmNewCustomer.vue